import { render, staticRenderFns } from "./searchHistory.vue?vue&type=template&id=244051bc&scoped=true&"
import script from "./searchHistory.vue?vue&type=script&lang=js&"
export * from "./searchHistory.vue?vue&type=script&lang=js&"
import style0 from "./searchHistory.vue?vue&type=style&index=0&id=244051bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244051bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('244051bc')) {
      api.createRecord('244051bc', component.options)
    } else {
      api.reload('244051bc', component.options)
    }
    module.hot.accept("./searchHistory.vue?vue&type=template&id=244051bc&scoped=true&", function () {
      api.rerender('244051bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/search/searchHistory.vue"
export default component.exports